"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4405],{

/***/ 614405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);


var EmptyWidget = function(props) {
    var html = props.html;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "empty-widget-container",
        children: html && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (EmptyWidget);


/***/ })

}]);